<template>
  <v-app>
    <router-view v-slot="{ Component }">
      <component :is="Component" />
    </router-view>
    <GlobalModal />
    <BottomNav v-if="showBottomNav" />
    <GlobalSnackbar />
  </v-app>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import BottomNav from '@/shared/components/navigation/BottomNav.vue'
import { useModalStore } from '@/shared/stores/modal'
import { useAppStore } from '@/shared/stores/app'
import { getAppModeFromEnv } from './shared/utils/appMode'

const GlobalModal = defineAsyncComponent(() => import('@/shared/components/feedback/GlobalModal.vue'))
const GlobalSnackbar = defineAsyncComponent(() => import('@/shared/components/feedback/GlobalSnackbar.vue'))

const route = useRoute()
const modal = useModalStore()
const appStore = useAppStore()
const HIDE_BOTTOM_NAV_ROUTES = new Set<string>([
  'marketplace.inspection-form',
  'marketplace.recurring-form',
  'marketplace.free-estimation.form',
  'marketplace.schedule-form',
  'join-as-vendor.form',
  'customer.messages.detail',
  'customer.quotations.detail',
  'vendor.profile-setup',
  'vendor.quotations.detail',
  'provider.appointment.survey',
  'provider.appointment.saved-templates',
  'signup.page',
  'vendor.apply-company-memberships',
  'vendor.messages.detail',
  'vendor.quotation.template.detail'

])

const showBottomNav = computed(() => {
  const routeName = typeof route.name === 'string' ? route.name : ''
  const hiddenByRoute = HIDE_BOTTOM_NAV_ROUTES.has(routeName)
  const hiddenByFullscreenModal = modal.isOpen && modal.options.fullscreen
  return !hiddenByRoute && !hiddenByFullscreenModal
})

onMounted(async () => {
  await appStore.loadAppInit()

  if (appStore.status === 'error') {
    localStorage.clear()
    await appStore.loadAppInit(true)
  }
})
</script>

<style scoped>
.v-application__wrap {
  padding-bottom: 0;
}


</style>
